<template>
  <div class="prescriberTreatmentAreaDetails">
    <card>
      <template v-slot>
        <div class="flex item-start">
          <div class="flex-shrink-0 content-center"><v-pen></v-pen></div>
          <div class="flex-1">
            <div class="text-2xl font-semibold leading-6 flex-1 mx-2">Behandelgebieden wijzigen</div>
          </div>
        </div>
        <div class="grid my-2">
          <div
            class="relative flex items-start max-h-10"
            v-for="(treatmentArea, index) in editableTreatmentAreas"
            :key="index"
          >
            <div class="flex px-2">
              <input
                :id="treatmentArea.id"
                :aria-describedby="treatmentArea.id"
                name="prescriberTreatmentArea"
                type="checkbox"
                v-model="treatmentArea.active"
                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
              />
              <label :for="treatmentArea.id" class="ml-3 block text-sm font-medium leading-6 text-black content-center">
                {{ treatmentArea.description }}
              </label>
            </div>
          </div>
        </div>
        <div class="flex flex-row justify-end gap-4 mt-4">
          <a
            class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
            @click.prevent="cancelTreatmentAreaDetailsSave()"
          >
            Annuleren
          </a>
          <button
            @click.prevent="saveTreatmentAreaDetails"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-cta rounded-full text-nowrap"
          >
            Wijzigen
          </button>
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import { ref, onMounted, getCurrentInstance } from 'vue';
import axios from 'axios';
import VPen from 'icons/Pen';
import { allTreatmentAreas$ } from '@/services';

export default {
  name: 'PrescriberTreatmentAreaDetails',
  components: { VPen },
  props: {
    treatmentAreaDetails: {
      type: Array,
      required: true
    }
  },
  emits: ['cancel', 'save'], // Declare emitted events
  setup(props, { emit }) {
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;
    const allTreatmentAreas = ref(null);
    const editableTreatmentAreas = ref([]);
    // Fetch all treatment areas
    allTreatmentAreas$.subscribe((value) => {
      allTreatmentAreas.value = value;

      // Initialize editableTreatmentAreas based on props and allTreatmentAreas
      const utas = props.treatmentAreaDetails.map((m) => m.treatmentAreaId);
      editableTreatmentAreas.value = allTreatmentAreas.value.map((m) => ({
        ...m,
        active: utas.includes(m.id),
        treatmentAreaId: m.id
      }));
    });

    onMounted(() => {});

    const cancelTreatmentAreaDetailsSave = () => {
      emit('cancel');
    };
    const saveTreatmentAreaDetails = () => {
      editableTreatmentAreas.value.map((area) => ({
        id: area.id,
        active: area.active
      }));
      axios
        .post('UserV2/UpdateUserTreatmentAreas', {
          UserTreatmentArea: editableTreatmentAreas.value
        })
        .then((response) => {
          emit('save', response.data);
        });
    };

    return {
      emit,
      cancelTreatmentAreaDetailsSave,
      saveTreatmentAreaDetails,
      editableTreatmentAreas
    };
  }
};
</script>
<style lang="scss" scoped>
.prescriberTreatmentAreaDetails {
  color: $teal-darkest;
  .material-design-icon {
    fill: $teal-darkest;
  }
}
</style>
